import { Card, Checkbox, Flex, Text } from '@radix-ui/themes';
import styles from './FacetItem.module.css';

interface FacetItemProps {
    label: string;
    total: number;
    matches: number;
    isActive: boolean;
    onClick: () => void;
}

export const FacetItem = ({
    label,
    total,
    matches,
    isActive,
    onClick,
}: FacetItemProps) => {
    const isAvailable = !(matches === 0 && total > 0);
    const showMatchesOnly = total === matches;

    return (
        <Card
            size={'1'}
            onClick={onClick}
            className={styles.facetItem}
            data-available={!(matches === 0 && !isActive)}
        >
            <Flex gap={'2'} align={'center'} className={styles.label}>
                <Text size={'1'}>
                    <Flex gap={'2'}>
                        <Checkbox
                            checked={isActive}
                            className={styles.facetItem}
                            highContrast={!isActive}
                            data-active={isActive}
                            data-available={isAvailable}
                            // onClick={onClick}
                        />
                        {label}
                    </Flex>
                </Text>

                {(!showMatchesOnly || (showMatchesOnly && !!matches)) && (
                    <Flex
                        className={styles.countWrapper}
                        align={'center'}
                        gap={'1'}
                    >
                        {/* <Text className={styles.matchesCount} size={'1'}>
                            {matches}
                        </Text> */}

                        <Text className={styles.matchesCount} size={'1'}>
                            {matches || total}
                        </Text>
                        {/* {!showMatchesOnly && (
                            <Text className={styles.totalCount} size={'1'}>
                                / {total}
                            </Text>
                        )} */}
                    </Flex>
                )}
            </Flex>
        </Card>
    );
};
